import React, { Component } from 'react';
import Ball from './ball';
import redBall from '../../assets/images/ball-icons/red_ball.png';
import yellowBall from '../../assets/images/ball-icons/yellow_ball.png';
import greenBall from '../../assets/images/ball-icons/green_ball.png';
import brownBall from '../../assets/images/ball-icons/brown_ball.png';
import blueBall from '../../assets/images/ball-icons/blue_ball.png';
import pinkBall from '../../assets/images/ball-icons/pink_ball.png';
import blackBall from '../../assets/images/ball-icons/black_ball.png';

class Break extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isBallPopUp: false,
      isClickedAtBottom: false
    };
    this.dropdownMenuRef = React.createRef();
  }

  getCount = (arr, num) => {
    return arr.filter(element => element === num).length;
  }

  componentDidMount() {
    document.body.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const { isBallPopUp } = this.state;
    if (isBallPopUp) {
      const dropdownMenu = this.dropdownMenuRef.current;
      if (dropdownMenu && !dropdownMenu.contains(event.target)) {
        this.toggleBallPopUp(event);
      }
    }
  };



  toggleBallPopUp = (event) => {
    const viewportHeight = window.innerHeight;
    const bottomThreshold = viewportHeight - 100;
    if (event.clientY >= bottomThreshold) {
      this.setState({ isClickedAtBottom: true });
      this.setState(prevState => ({
        isBallPopUp: !prevState.isBallPopUp
      }));
    } else {
      this.setState({ isClickedAtBottom: false });
      this.setState(prevState => ({
        isBallPopUp: !prevState.isBallPopUp
      }));
    }
  };

  ballIncrement = (ball) => {
    this.props.ballIncrement(ball);
  }

  ballDecrement = (ball) => {
    this.props.ballDecrement(ball);
  }

  addBreak(player, frameNumber) {
    this.props.addBreak(player, frameNumber);
  }



  render() {
    const { player, balls, breakNumber, frameNumber, isBreakAdd } = this.props;
    const { isBallPopUp, isClickedAtBottom } = this.state;
    const ballTypes = [
      { id: 1, imgSrc: redBall },
      { id: 2, imgSrc: yellowBall },
      { id: 3, imgSrc: greenBall },
      { id: 4, imgSrc: brownBall },
      { id: 5, imgSrc: blueBall },
      { id: 6, imgSrc: pinkBall },
      { id: 7, imgSrc: blackBall }
    ];

    return (
      <div key={breakNumber}>
        <div
          className={`ball-adj selected dropdown ${isBreakAdd ? "add-break" : ""} ${player === "2" ? "dropdown-menu-right" : ""} ${isBallPopUp ? `selected-break ${isClickedAtBottom ? 'selected-break-bottom' : ''}` : ""}`}
          type="button"
          ref={this.dropdownMenuRef}
          onClick={isBreakAdd ? () => this.addBreak(player, frameNumber) : (e)=>this.toggleBallPopUp(e)}
        >
          {isBreakAdd && <span className=''>
            <svg xmlns="http://www.w3.org/2000/svg" height="24" stroke='#cccccc' fill='#cccccc' width="24" viewBox="0 0 448 512"><path d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z" /></svg>
          </span>}
          {!isBreakAdd &&
            <>
              {balls && balls.reduce((acc, curr) => acc + curr, 0)}
              {this.state.isBallPopUp &&
                <div className="dropdown-menu ball-dropdown show"
                  onClick={(event) => { event.stopPropagation() }}
                >
                  <div className="d-flex dropdownMenu">
                    {ballTypes.map(ball => (
                      <Ball
                        key={ball.id}
                        ball={ball}
                        balls={balls}
                        getCount={this.getCount}
                        ballIncrement={this.props.ballIncrement}
                        ballDecrement={this.props.ballDecrement}
                        breakNumber={breakNumber}
                        frameNumber={frameNumber}
                        player={player}
                      />
                    ))}
                  </div>
                </div>
              }
            </>
          }

        </div>
      </div>
    );
  }
}

export default Break;
